
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Artigos = lazy(() => import('../pages/artigos/page'));
const ArtigoSlug = lazy(() => import('../pages/artigos/[slug]/page'));
const Servicos = lazy(() => import('../pages/servicos/page'));
const ServicoSlug = lazy(() => import('../pages/servicos/[slug]/page'));
const ServicosPage = lazy(() => import('../pages/servicos-page/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const Informativos = lazy(() => import('../pages/informativos/page'));
const InformativoSlug = lazy(() => import('../pages/informativos/[slug]/page'));
const Feedbacks = lazy(() => import('../pages/feedbacks/page'));
const Admin = lazy(() => import('../pages/admin/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/servicos',
    element: <ServicosPage />,
  },
  {
    path: '/sobre',
    element: <SobrePage />,
  },
  {
    path: '/artigos',
    element: <Artigos />,
  },
  {
    path: '/artigos/:slug',
    element: <ArtigoSlug />,
  },
  {
    path: '/servicos/:slug',
    element: <ServicoSlug />,
  },
  {
    path: '/informativos',
    element: <Informativos />,
  },
  {
    path: '/informativos/:slug',
    element: <InformativoSlug />,
  },
  {
    path: '/feedbacks',
    element: <Feedbacks />,
  },
  {
    path: '/admin',
    element: <Admin />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboard />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
